import { combineReducers } from 'redux';
import appStore from './appReducer';


export default combineReducers({

  appStore,

});
